import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./asset/stylesheet/base.css";

const root = ReactDOM.createRoot(document.getElementById("app"));
console.log("夕航科技官网");
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
